<template>
    <DsCard class="simple-text-card">
        <div>
            <NewIllustration :name="illustrationName" />
        </div>

        <strong>{{ $t('unlayerBuilder.templateSelection.cards.simpleText.title') }}</strong>

        <p>{{ $t('unlayerBuilder.templateSelection.cards.simpleText.description') }}</p>

        <DsOutlineButton
            :disabled="disabled"
            :loading="loading"
            @click="$emit('select')"
        >
            {{ $t('unlayerBuilder.templateSelection.cards.button.label.selectTemplate') }}
        </DsOutlineButton>
    </DsCard>
</template>

<script>
import NewIllustration from '@/components/funnel/ds-core-dupes/NewIllustration/NewIllustration.vue';

export default {
    components: {
        NewIllustration
    },

    props: {
        disabled: Boolean,
        loading: Boolean,
        emailsThryvThemeEnabled: Boolean,
    },

    computed: {
        illustrationName() {
            return this.emailsThryvThemeEnabled ? 'text-only-broadcast-dex' : 'text-only-broadcast';
        },
    },
};
</script>


<style lang="scss" scoped>
.simple-text-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: $spacing-400;

    strong {
        margin: 0;
        text-align: center;
        font-size: $font-size-lg;
    }

    p {
        margin: 0;
        text-align: center;
        font-size: $font-size-sm;
        color: $color-text-subtle;
    }
}
</style>
